import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F6F8]" data-testid="loading-screen">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-3 border-[#F97D6A] border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-gray-500 font-['DM_Sans']">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const allowed = roles && (roles.includes(user.role)
    || (roles.includes('partner') && user.is_partner));
  if (roles && !allowed) {
    const dashPath = user.role === 'admin' ? '/admin' : user.role === 'coordinator' ? '/coordinator'
      : user.role === 'parent' ? '/parent' : user.role === 'partner' ? '/partner' : '/';
    return <Navigate to={dashPath} replace />;
  }

  return children;
}
